export default __webpack_public_path__ + "static/media/it-23.e241511a.svg";